import { module } from 'modujs';
import gsap from 'gsap';
import { Draggable } from 'gsap/all';
gsap.registerPlugin(Draggable);

export default class extends module {
    constructor(m) {
        super(m);

        this.render = this.el.querySelector('.m-before-after_render');
        this.media2 = this.el.querySelector('.m-before-after_media2');
        this.handle = this.el.querySelector('.m-before-after_handle');
        this.mask = this.el.querySelector('.m-before-after_mask');
    }

    init() {
        let percentage = 0;
        gsap.set([this.media2, this.mask], { clipPath: `polygon(0 0, ${percentage * 100}% 0, ${percentage * 100}% 100%, 0 100%)` });

        this.drag = Draggable.create(this.handle, {
            type: 'x',
            bounds: this.el,
            throwProps: true,
            onDrag: (e) => {
                let size = this.drag[0].maxX - this.drag[0].minX;
                let position = this.drag[0].endX - this.drag[0].minX;
                let percentage = position / size;
                gsap.set([this.media2, this.mask], { clipPath: `polygon(0 0, ${percentage * 100}% 0, ${percentage * 100}% 100%, 0 100%)` });
            },
        });
    }

    initDrag() {
        let percentage = 0.5;
        gsap.to([this.media2, this.mask], { clipPath: `polygon(0 0, ${percentage * 100}% 0, ${percentage * 100}% 100%, 0 100%)`, duration: 1.2, ease: 'power4.inOut' });
        gsap.to(this.handle, { left: '50%', duration: 1.2, ease: 'power4.inOut' });
    }
}
